import { useEffect, useState, useRef } from 'react';
import LoadingSpinner from '../components/layout/LoadingSpinner';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useSearchParams } from 'react-router-dom';

const StudentList = () => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [url, setUrl] = useState('');
    const productType = useSelector((state: RootState) => state.product);
    const token = useSelector((state: RootState) => state.auth.token);
    const user = useSelector((state: RootState) => state.auth.user);
    const [searchParams] = useSearchParams();
    const showMark = searchParams.get('showMark');

    useEffect(() => {
        const stored = localStorage.getItem('user');
        if (stored) {
            let localData = JSON.parse(stored);

            const selectedSchool =
                user?.su[0]?.schoolid || (user?.su[0]?.id as number);
            let url = '';
            let { su, ...userWithoutSu } = localData;
            let userData = {
                user: userWithoutSu,
                auth_token: token,
                toolbar: false,
                productType: productType,
                xClientApp: productType,
                hideBackBtn: true,
                showMark: showMark || false,
                selectedAcadYear: localData.su[0].acadyears[0] || localData.su[0].acadyears[0],
            };
            let encodedUserSessionData = btoa(JSON.stringify(userData));
            url = `${process.env.REACT_APP_NUCLEUS_ACTIVE_TEACH_URL}/v2/migrated/${selectedSchool}/students-list?data=${encodedUserSessionData}`;
            setUrl(url);
            setIsLoading(false);
        }
    }, [token, showMark]);

    const handleLoad = () => {
        setIsLoading(false);
    };

    return (
        <div className="w-full h-full">
            {isLoading && <LoadingSpinner />}
            {!isLoading && (
                <iframe
                    ref={iframeRef}
                    className="content-iframe w-full h-full transition-opacity duration-500 ease-in-out"
                    title="Student List"
                    src={url}
                    onLoad={handleLoad}
                    style={{
                        opacity: isLoading ? 0 : 1,
                    }}
                ></iframe>
            )}
        </div>
    );
};

export default StudentList;
